// removed by extract-text-webpack-plugin
module.exports = {"pageHeader":"-z6A5EGZa7gEopN6DWT2-","noBottom":"_1jI7hA_1Gdrt7SuYM5YcqR","field":"_220DL0kmBpwgpw6ldzqR1c","loading":"_36Suc3yPVrKdwND9ViJOBm","profilePanel":"_1WhIDLHHMzkaE4Q0qpVew4","cardSection":"_1UKHT83don3x62O73EgkLU","spaced":"xDftsyI0mNDKQ65IjKevH","hidden":"jDEtQx-2hanXBUIlEeZk2"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Profile/style.scss
// module id = 2537
// module chunks = 1